import { useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { message } from 'antd';
import useAddAttachment from './useAddAttachment';

const onCreateTransport = async ({ attachments, ...value }) => {
  return request.post(
    '/HousingStock/transport',
    value,
    'При привязки транспорта произошла ошибка',
    'Error'
  );
};

const useCreateTransport = (onSuccess) => {
  const { mutateAsync: addAttachment, isLoading } = useAddAttachment();

  const mutation = useMutation(onCreateTransport, {
    onSuccess: async (data, { number, region, model, brand, attachments }) => {
      if (data === 'Error') return;

      if (!!attachments?.length && !!data?.id) {
        const promises = [];

        attachments.map((attach) =>
          promises.push(
            addAttachment({ transportId: data?.id, file: attach?.file })
          )
        );

        await Promise.all(promises);
      }

      message.success(
        `ТС ${brand} ${model}, ${number} ${region} было успешно добавлено`,
        2
      );

      if (typeof onSuccess === 'function') onSuccess(data?.id);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading || isLoading,
  };
};

export default useCreateTransport;
